// pages/EditUserModalForm/index.jsx
import React, { useState } from 'react';
import { CircularProgress, Button } from '@mui/material';
import useUserDataPreFill from './useUserDataPreFill';
import useEditUserForm from './useEditUserForm';
import DynamicFieldRenderer from './DynamicFieldRenderer';
import * as S from '../styles';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditUserModalForm = ({ formFields, clubForms, handleClose, userData }) => {
  const [cellphone, setCellPhone] = useState('');
  const [inputMask, setInputMask] = useState('(99) 99999-9999');
  const [currentDDD, setCurrentDDD] = useState('+55');
  const [currentCountry, setCurrentCountry] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { partnerData, setPartnerData, handleSubmit, loading } = useEditUserForm({
    clubForms,
    userData,
    handleClose,
  });

  useUserDataPreFill({
    userData,
    clubForms,
    formFields,
    setPartnerData,
    setCellPhone,
    setInputMask,
    setCurrentCountry,
    setCurrentDDD,
    setLoading: setIsLoading,
  });

  const treatmentCep = async (e) => {
    const inputValue = e.target.value.replace(/\D/g, '');
    console.log(e.target.id);

    if (inputValue.length > 8) return;
    const formatted = inputValue.replace(/(\d{5})(\d{1,3})/, '$1-$2');
    console.log(inputValue, ' - inputValue length: ', inputValue.length);

    setPartnerData((prev) => ({
      ...prev,
      zipCode: formatted,
    }));

    if (inputValue.length === 8) {
      setIsLoading(true);
      const toastId = toast('Buscando informações do CEP...', {
        type: 'info',
        isLoading: true,
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
      });

      axios
        .get(`https://viacep.com.br/ws/${inputValue}/json/`)
        .then((response) => {
          response = response.data;
          if (response.erro) {
            toast.update(toastId, {
              render: 'CEP inválido',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
              closeButton: true,
            });
          }

          setPartnerData((prev) => ({
            ...prev,
            zipCode: inputValue,
            city: response.localidade,
            neighborhood: response.bairro,
            state: response.uf,
            streetAve: response.logradouro,
            streetNumber: '',
            complement: '',
          }));

          console.log(partnerData, 'Dados do CEP atualizados');
        })
        .catch((error) => {
          console.error(error, 'Erro ao obter informações do CEP');
          toast.update(toastId, {
            render: 'Erro ao obter informações do CEP',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
            closeButton: true,
          });
        })
        .finally(() => {
          setIsLoading(false);
          toast.update(toastId, {
            render: 'Informações do CEP atualizadas',
            type: 'success',
            isLoading: false,
            autoClose: 2000,
            closeButton: true,
          });

          document.getElementById(e.target.id).focus();
        });
    }
  };

  const handleChangeCellphone = (event, key) => {
    setCellPhone(event.target.value);
    setPartnerData((prev) => ({
      ...prev,
      [key]: '+' + (currentDDD + event.target.value).replace(/\D/g, ''),
    }));
  };

  const handleChangeCheck = (key) => {
    setPartnerData((prev) => {
      const current = prev[key];
      if (typeof current === 'object' && current !== null) {
        return {
          ...prev,
          [key]: {
            ...current,
            accept: !current.accept,
          },
        };
      }
      return {
        ...prev,
        [key]: !current,
      };
    });
  };

  const handleCountryChange = (e) => {
    const valuesArr = e.target.value.split(',');
    setCellPhone('');
    setCurrentDDD(valuesArr[0]);
    setInputMask(valuesArr[1]);
    setCurrentCountry(e.target.value);
  };

  if (isLoading || !formFields) {
    return (
      <S.ModalMessageContainer>
        Carregando dados do usuário... <br />
        <CircularProgress />
      </S.ModalMessageContainer>
    );
  }

  return (
    <S.RegisterUnitForm onSubmit={handleSubmit}>
      {formFields.map((field, index) => (
        <DynamicFieldRenderer
          key={index}
          field={field}
          partnerData={partnerData}
          setPartnerData={setPartnerData}
          handleChangeCellphone={handleChangeCellphone}
          handleChangeCheck={handleChangeCheck}
          treatmentCep={treatmentCep}
          currentCountry={currentCountry}
          handleCountryChange={handleCountryChange}
          cellphone={cellphone}
          inputMaskCellphone={inputMask}
          clubForms={clubForms}
        />
      ))}

      <Button type="submit" variant="contained" color="primary" disabled={loading}>
        {loading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : 'Salvar'}
      </Button>
    </S.RegisterUnitForm>
  );
};

export default EditUserModalForm;
